export enum AccessGapTypeEnum {
    Unknown = "unknown",
    NoGap = "noGap",
    UnfillableGap = "unfillableGap",
    PartiallyFillableGap = "partiallyFillableGap",
    FillableBySingleProvider = "fillableBySingleProvider",
    FillableGap = "fillableGap"
}